export const mySkills = [
    {
        id: 1,
        title: "Frontend",
        items: [
            "React.js",
            "Next.js",
            "React Native (Expo & Bare Workflow)",
            "JavaScript (ES6+)",
            "TypeScript",
            "HTML5",
            "CSS3",
            "SASS",
            "Tailwind CSS",
            "Material UI (MUI)",
            "Bootstrap",
            "Mantine",
            "NativeBase",
        ],
    },
    {
        id: 2,
        title: "State Management",
        items: [
            "Redux Toolkit",
            "RTK Query",
            "React Context API",
        ],
    },
    {
        id: 3,
        title: "Backend & APIs",
        items: [
            "Node.js",
            "Express.js",
            "Strapi Headless CMS",
            "REST API Integration",
            "WebSocket",
        ],
    },
    {
        id: 4,
        title: "Mobile Development",
        items: [
            "React Native",
            "Cross-Platform Mobile Development",
            "Mobile UI Development",
        ],
    },
    {
        id: 5,
        title: "Database",
        items: [
            "MongoDB",
            "MySQL",
            "PostgreSQL",
        ],
    },
    {
        id: 6,
        title: "Tools & Platforms",
        items: [
            "Git",
            "GitHub",
            "TurboRepo",
            "VS Code",
            "Android Studio",
            "Xcode",
            "Figma",
        ],
    },
    {
        id: 7,
        title: "Web Performance & Architecture",
        items: [
            "Server-Side Rendering (SSR)",
            "Static Site Generation (SSG)",
            "Responsive Web Design",
            "Performance Optimization",
            "Component-Based Architecture",
        ],
    },
    {
        id: 8,
        title: "Programming Languages",
        items: [
            "JavaScript",
            "TypeScript",
            "Python",
            "Java",
            "C",
            "C++",
        ],
    },
    {
        id: 9,
        title: "Soft Skills",
        items: [
            "Problem Solving",
            "Team Collaboration",
            "Communication",
            "Adaptability",
            "Continuous Learning",
            "Time Management",
        ],
    },
    {
        id: 10,
        title: "Languages",
        items: [
            "Bengali (Native)",
            "English (Professional Working Proficiency)",
            "Hindi / Urdu (Conversational)",
        ],
    },
];